<template>
  <div>
    <el-row class="bottmBg">
      <el-col :span="5">&nbsp;</el-col>
      <el-col :span="14" class="btnmiddle">
        <ul>
          <li v-for="(item, index) in xtlist" :key="index">
            <div>
              <router-link :to="item.manageUrl">
                <div class="systemInfo">{{ item.menuName }}</div>
              </router-link>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      xtlist: [],
    };
  },
  mounted() {
    this.getSystem();
  },
  methods: {
    getSystem() {
      let self = this;
      self.$http.post(
        self.api.usersIndex,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        (res) => {
          if (res.code == 200) {
            self.xtlist = res.body.xtList;
          }
        },
        (error) => {}
      );
    },
  },
};
</script>
<style>
.bottmBg ul li a {
  color: #fff;
  text-decoration: none;
}
.bottmBg {
  width: 100%;
  height: 160px;
  position: absolute;
  bottom: 0;
  z-index: 1000;
}
.bottmBg ul {
  clear: both;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
.bottmBg ul li {
  width: 20%;
  float: left;
  text-align: center;
  height: 58px;
  line-height: 58px;
  border: 1px solid #4abeff;
  box-shadow: #4abeff 0px 0px 30px inset;
}
.btnmiddle {
  position: fixed;
  bottom: 100px;
  padding: 15px;
  left: 21%;
}
.btnmiddle img {
  width: 80px;
}
</style>


// WEBPACK FOOTER //
// src/view/role.vue